import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserCard } from "../../store/card/selectors";
import { cardActions } from "../../store/card";
import { cards, user } from "../../lib/api/api";
import iconLogoTV from "../../assets/images/elems/logo-tv.svg";
import iconLogoMobile from "../../assets/images/elems/logo-mobile-short.svg";

const Agreement = () => {
  const [processingCheck, setProcessingCheck] = useState(false);
  const [advCheck, setAdvCheck] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const card = useSelector(getUserCard);
  const [policyLink, setPolicyLink] = useState("");
  const [consentLink, setConsentLink] = useState("");

  useEffect(() => {
    submitForm();
    if (!card.loading) {
      cards
        .userCard()
        .then((res) => {
          if (res[0].billing_id === "1") {
            setPolicyLink(
              "https://static.telekarta.tv/policy/PrivacyPolicyOrion.pdf",
            );
            setConsentLink(
              "https://static.telekarta.tv/policy/ApprovalLkaAbonentsOrionExpress.pdf",
            );
          } else if (res[0].billing_id === "2") {
            setPolicyLink(
              "https://static.telekarta.tv/policy/PrivacyPolicyTelekarta.pdf",
            );
            setConsentLink(
              "https://static.telekarta.tv/policy/ApprovalLkaAbonentsTelekarta.pdf",
            );
          }
          dispatch(
            cardActions.setCard({
              title: res[0].title,
              cardID:
                res[0].hasOwnProperty("card_control") &&
                res[0].card_control !== ""
                  ? res[0].card_id + res[0].card_control
                  : res[0].card_id,
              ID: res[0].id,
              billingID: res[0].billing_id,
              loading: true,
            }),
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (card.billingID === "1") {
        setPolicyLink(
          "https://static.telekarta.tv/policy/PrivacyPolicyOrion.pdf",
        );
        setConsentLink(
          "https://static.telekarta.tv/policy/ApprovalLkaAbonentsOrionExpress.pdf",
        );
      } else if (card.billingID === "2") {
        setPolicyLink(
          "https://static.telekarta.tv/policy/PrivacyPolicyTelekarta.pdf",
        );
        setConsentLink(
          "https://static.telekarta.tv/policy/ApprovalLkaAbonentsTelekarta.pdf",
        );
      }
    }
    user
      .userInfo()
      .then((res) => {
        res.permissions.forEach((item) => {
          if (item.type === "user.agree") {
            setProcessingCheck(true);
          }
          if (item.type === "user.adv") {
            setAdvCheck(true);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function submitForm() {
    const formElement = document.getElementById("processing__form__main");
    formElement.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(formElement);
      user
        .agreement(
          formData.get("agree_processing") === "1" ? 1 : 0,
          formData.get("agree_processing") === "1" ? 1 : 0,
          formData.get("agree_adv") === "1" ? 1 : 0,
        )
        .then((res) => {
          res.permissions.forEach((item) => {
            if (item.type === "user.agree") {
              navigate("/");
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  return (
    <>
      <div className="page page--index page--partner">
        <header
          className="header header--miserable"
          style={{ boxShadow: "none" }}
        >
          <div className="header__top header__top--grey">
            <div className="header__container header__top-wrap">
              <Link
                className="header__lk-logo-link header__lk-logo-link--tablet"
                to="//my.telekarta.tv"
              >
                <img
                  className="header__logo-tablet"
                  src={iconLogoTV}
                  alt="Телекарта логотип"
                  width="190"
                  height="48"
                />
              </Link>
            </div>
          </div>
          <div className="header__bottom">
            <Link
              className="header__lk-logo-link header__lk-logo-link--mobile"
              to="//my.telekarta.tv"
            >
              <img
                className="header__logo-mobile"
                src={iconLogoMobile}
                alt="Телекарта логотип"
                width="125"
                height="48"
              />
            </Link>
          </div>
        </header>
        <main className="page__main">
          <div className="page-container basic-article__container">
            <div
              id="processing__form__main__block"
              className="wysiwyg"
              style={{ paddingTop: "10%", width: 600, maxWidth: "100%" }}
            >
              <h2>
                Согласие на обработку персональных данных и получение рекламы
              </h2>
              <p className="text text--sub">
                Для продолжения работы в Личном кабинете необходимо подтвердить
                Ваше согласие на обработку персональных данных и получение
                рекламы
              </p>
              <form id="processing__form__main" method="POST">
                <div className="form__form-body">
                  <div className="form__line">
                    <div className="form__item">
                      <div className="checkbox ">
                        <input
                          className="checkbox__input"
                          id="agree_processing"
                          type="checkbox"
                          name="agree_processing"
                          value={processingCheck ? 1 : 0}
                          checked={processingCheck}
                          onClick={() => {
                            setProcessingCheck(!processingCheck);
                          }}
                        />
                        <label
                          className="checkbox__label pt-0"
                          for="agree_processing"
                        >
                          <span className="checkbox__text">
                            Даю{" "}
                            <Link to={consentLink} target="_blank">
                              согласие
                            </Link>{" "}
                            на обработку персональных данных в соответствии с{" "}
                            <Link to={policyLink} target="_blank">
                              Политикой обработки персональных данных
                            </Link>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form__line">
                    <div className="form__item">
                      <div className="checkbox ">
                        <input
                          className="checkbox__input"
                          id="agree_adv"
                          type="checkbox"
                          name="agree_adv"
                          value={advCheck ? 1 : 0}
                          checked={advCheck}
                          onClick={() => {
                            setAdvCheck(!advCheck);
                          }}
                        />
                        <label className="checkbox__label" for="agree_adv">
                          <span className="checkbox__text">
                            Даю согласие на{" "}
                            <Link
                              to="https://www.telekarta.tv/include/content/subscription_agreement/ru/files/pr_7.pdf"
                              target="_blank"
                            >
                              получение рекламы
                            </Link>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form__line">
                    <div className="form__item">
                      <button
                        className="solid-btn solid-btn--lg solid-btn--blue bttn"
                        type="submit"
                      >
                        Далее
                      </button>
                      <Link
                        className="ghost-btn ghost-btn--lg ghost-btn--blue bttn"
                        to="//my.telekarta.tv"
                        style={{ marginLeft: 5 }}
                      >
                        На главную
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </main>
        <footer className="footer page__footer">
          <div
            className="footer__bottom footer__container page-container"
            style={{ borderTop: 0 }}
          >
            <div className="footer__copyright">
              <p className="footer__copyright-text">
                © 2026 ООО «ТЕЛЕКАРТА» — спутниковое телевидение ООО «ОРИОН
                ЭКСПРЕСС»
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Agreement;
